import { Controller } from 'stimulus'
import { gsap } from 'gsap/all'

export default class extends Controller {
  static targets = ['checkbox', 'count', 'actions', 'clearLink']

  render() {
    if (this.hasClearLinkTarget) {
      this.clearLinkTarget.click()
    } else {
      this.countTarget.innerHTML = this.selections.length
      if (this.selections.length > 0) {
        this.show()
      } else {
        this.hide()
      }
    }
  }

  toggleAll(e) {
    for(let checkbox of this.checkboxTargets) {
      checkbox.checked = e.target.checked
    }
    this.render()
  }

  show() {
    gsap.to(this.actionsTarget, .3, { autoAlpha: 1, display:'table-row' })
  }

  hide() {
    gsap.to(this.actionsTarget, .3, { autoAlpha: 0, display:'none' })
  }

  get selections() {
    return this.checkboxTargets.filter(c => c.checked)
  }
}
